// Constants cho file upload - dùng chung cho toàn bộ ứng dụng
export const MAX_FILE_SIZE = 80 * 1024 * 1024; // 80MB
export const CHUNK_SIZE = 200 * 1024; // 200KB - theo CreateIncomingDocumentDialog.tsx
